import React from 'react';
import { decodeToken } from 'react-jwt';

import { Navigate, Outlet } from 'react-router-dom';

function PrivateRoute() {
	// eslint-disable-next-line consistent-return
	const checkIfUserIsAuthenticated = () => {
		if (localStorage.getItem('user')) {
			const { accessToken } = JSON.parse(
				localStorage.getItem('user')
			).stsTokenManager;

			if (!accessToken) {
				return false;
			}

			try {
				const decodedToken = decodeToken(accessToken);
				if (decodedToken.exp < Date.now() / 1000) {
					return false;
				}

				return true;
			} catch (err) {
				return false;
			}
		}
	};

	const isAuthenticated = checkIfUserIsAuthenticated();

	return isAuthenticated ? <Outlet /> : <Navigate to='/login' />;
}

export default PrivateRoute;
